import { isWebViewMode } from './webviewBridge';

const RATIONALE_DONE_KEY = 'circlus_mic_rationale_done';

function isRationaleDone(): boolean {
  try {
    return localStorage.getItem(RATIONALE_DONE_KEY) === 'true';
  } catch {
    return false;
  }
}

function markRationaleDone(): void {
  try {
    localStorage.setItem(RATIONALE_DONE_KEY, 'true');
  } catch {
    // ignore
  }
}

export type MicRationaleDetail = {
  resolve: () => void;
  reject: () => void;
};

/**
 * In WebView mode, shows an in-app rationale dialog explaining why microphone
 * access is needed, before the OS system permission dialog appears.
 * Only shown once; subsequent calls resolve immediately.
 */
export function showMicrophoneRationaleIfNeeded(): Promise<void> {
  if (!isWebViewMode || isRationaleDone()) {
    return Promise.resolve();
  }
  return new Promise<void>((resolve, reject) => {
    const detail: MicRationaleDetail = {
      resolve: () => {
        markRationaleDone();
        resolve();
      },
      reject: () => {
        reject(new Error('Microphone rationale dismissed'));
      }
    };
    window.dispatchEvent(new CustomEvent<MicRationaleDetail>('app:mic-rationale', { detail }));
  });
}
